export const CART_SET_REGION = '@CART_SET_REGION'

export default {
  CART_SET_REGION
}
